module.exports = __webpack_public_path__ + "img/68a7779.jpg";